// extracted by css-extract-rspack-plugin
export default {"list":"list-EiW_HD"};